import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import type { IProps } from './billing-subscription-container';
import Suspense from '../../../../shared/components/suspense';
import ErrorBoundaryWrapper from '../../../../shared/components/error-boundary-wrapper';
import retryLazy from '../../../retry-lazy';
import { Routes } from '../../../../shared/routes';
// import OutreachPlans from './components/outreach-plans';
import ModifyLeadFinderSubscription from './components/modify-lead-finder-subscription';
import ModifySubscription from './components/modify-subscription';
import ModifyInboxRadarSubscription from './components/modify-inbox-radar-subscription';

const SubscriptionInfo = React.lazy(() =>
  retryLazy(
    () =>
      import(
        /* webpackChunkName: "subscription-info" */ './components/subscription-info'
      ),
  ),
);
const UpgradePlanTabs = React.lazy(() =>
  retryLazy(
    () =>
      import(
        /* webpackChunkName: "upgrade-plan-tabs" */ './components/upgrade-plan-tabs'
      ),
  ),
);

const BillingSubscription: React.FC<IProps> = (props) => {
  useEffect(
    () => () => {
      const { resetSubscription } = props;
      resetSubscription();
    },
    [],
  );

  return (
    <div className="billing-subscription">
      <ErrorBoundaryWrapper>
        <Suspense>
          <Switch>
            <Route path="/billing/subscriptions" exact>
              <SubscriptionInfo containerProps={props} />
            </Route>
            <Route path="/billing/subscriptions/:tab" exact>
              <SubscriptionInfo containerProps={props} />
            </Route>
            <Route
              path={`${Routes.Setting_Billing_Upgrade_Email_Outreach_Plan}`}
              exact
            >
              <ModifySubscription />
            </Route>
            <Route
              path={`${Routes.Setting_Billing_Upgrade_Lead_Finder_Plan}`}
              exact
            >
              <ModifyLeadFinderSubscription />
            </Route>
            <Route
              path={`${Routes.Setting_Billing_Inbox_Placement_Radar}`}
              exact
            >
              <ModifyInboxRadarSubscription />
            </Route>
            <Route path={`${Routes.Setting_Billing_Upgrade_Plan}`} exact>
              <UpgradePlanTabs />
            </Route>
            <Route path={`${Routes.Setting_Billing_Upgrade_Plan_BFCM}`} exact>
              <UpgradePlanTabs />
            </Route>
            {/* <Route path={`${Routes.Setting_Billing_Upgrade_Plan}/:tab`} exact>
              <OutreachPlans />
            </Route> */}
            <Route
              path={`${Routes.Setting_Billing_Upgrade_Plan_BFCM}/:tab`}
              exact
            >
              <UpgradePlanTabs />
            </Route>
            <Redirect to="/billing/subscriptions" />
          </Switch>
        </Suspense>
      </ErrorBoundaryWrapper>
    </div>
  );
};

export default BillingSubscription;
